import { useNavigate } from 'react-router-dom'
import { SliceApiError } from '../data/types'

export type LimitReason = 'limit' | 'locked'

/**
 * Отказ по тарифу или сбой: лимит тарифа (409 с кодом), подписка закончилась
 * (423, клуб только для чтения) или всё остальное.
 */
export function limitReason(e: unknown): LimitReason | 'failed' {
  if (e instanceof SliceApiError && e.kind === 'limit') return e.message === 'soft_locked' ? 'locked' : 'limit'
  return 'failed'
}

/**
 * Отказ по тарифу - правило, а не сбой: что случилось и куда идти. Общий для
 * групп, тренеров и спортсменов.
 */
export function LimitNote({ what, reason, hint }: { what: string; reason: LimitReason; hint?: string }) {
  const navigate = useNavigate()
  return (
    <div className="pc-note" role="alert">
      {reason === 'locked'
        ? 'Подписка клуба закончилась: клуб сейчас только для чтения. Ничего не создано.'
        : `На текущем тарифе ${what} больше не создать. Ничего не создано: добавить можно после смены тарифа.`}
      {reason === 'limit' && hint ? ` ${hint}` : null}
      <button type="button" className="pc-btn pc-btn--block" style={{ marginTop: 8 }} onClick={() => navigate('/club/subscription')}>
        Открыть подписку клуба
      </button>
    </div>
  )
}
